document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll(".scroll-video");

    if (videos.length > 0) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const video = entry.target;

                if (entry.intersectionRatio >= 0.5) {
                    if (!video.dataset.played) {
                        video.play();
                        video.dataset.played = "true"; 
                        video.style.opacity = 1;
                    }
                }
            });
        }, { threshold: [0.5] });

        videos.forEach(video => observer.observe(video));
    }

    document.addEventListener("visibilitychange", function () {
        if (!document.hidden) { 
            document.querySelectorAll(".scroll-video").forEach(video => {
                setTimeout(() => { 
                    if (video.loop) {
                        video.play();
                    } else if (video.ended) {
                        video.currentTime = 0;
                        video.play();
                    } else if (video.paused) {
                        video.play();
                    }
                }, 200);
            });
        }
    });
});
